import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_STRADE_API } from '@/service'
const PREFIX_TRADE = PREFIX_STRADE_API + 'strade/'
/**
 * 获取代客下单信息
 * @param {string | number} helpOrderId - 代课下单ID
 */
export async function fetchValetOrderInfo(helpOrderId) {
  const { uid, skey } = await utils.ensureLogin()
  let param = encodeURI(
    JSON.stringify({ uid, skey, helpOrderId, businesstype: 21, utm: 2 })
  )
  const url = `${PREFIX_TRADE}helpConfirmOrder.do?param=${param}`
  console.log(param)
  try {
    const res = await fetch(url)
    const json = await res.json()
    if (+json.code === 1) {
      return json.data
    }
    return null
  } catch (error) {
    throw error
  }
}
let vOrderInfo = null
let isFetched = 0
/**
 * @typedef {{couponAmount,couponDesc,couponName,couponType,couponPassword,useStartTime,useEndTime,useAmountLimit}} coupon
 * @typedef {Object} valetOrderInfo
 * @property {string} serviceTime - 预产期
 * @property {string} remark - 备注
 * @property {{shareCode: string}} shareDetail -分享赚编码
 * @property {{price: number, orginprice: string}} priceInfo -价格信息 原价（若channelType为5，则该值为兑换所需积分） 下架
 * @property {{headPicUrl: string, workerName:string, workerCode: string, starLevel: number,serviceDays: number}} workerInfo -月嫂信息
 * @property {{workerCode, workerName}} inviteInfo -服务顾问
 * @property {coupon[]} couponInfo -可用券信息
 * @property {coupon[]} unableCouponInfo
 * @returns {valetOrderInfo}
 */
export async function getValetOrderInfo() {
  if (isFetched === 0) {
    // console.log('fetch once')
    isFetched = 1
    const parsed = queryString.parse(location.search)
    const helpOrderId = parsed.helperOrderId
    if (helpOrderId) {
      vOrderInfo = await fetchValetOrderInfo(helpOrderId)
    }
    isFetched = 2
  } else if (isFetched === 1) {
    return new Promise(resolve => {
      setTimeout(() => {
        // console.log('setTimeout', +new Date())
        resolve(getValetOrderInfo())
      }, 300)
    })
  }
  // console.log('fetched', +new Date())
  return vOrderInfo
}
